import { pipe } from 'ramda';
import HeroSpecial from './modules/hero-special';

pipe(HeroSpecial)();



// WEBPACK FOOTER //
// ../src/scripts/hero-special.js